import styled from 'styled-components';
import { Link } from '../../../../components/Link/Link';
export const StyledLogo = styled(Link) `
  display: flex;
  flex-direction: column;
  text-decoration: none;
`;
export const LogoText = styled.span `
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  line-height: 8px;
  margin-top: 4px;
  margin-bottom: 4px;
  text-align: end;
`;
export const LogoHeading = styled.h1 `
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  line-height: 8px;
  margin-top: 4px;
  margin-bottom: 4px;
  text-align: end;
`;
//# sourceMappingURL=Logo.styled.js.map